import * as AccessToken from './UseAccessToken';
import * as User from './UseAuthUser';

export const useAuthUser = User.useAuthUser;
export const useAccessToken = AccessToken.useAccessToken;
